'use client'

import { memo } from 'react'
import HoldingCard from '../HoldingCard'
import { Holding } from '@hooks/useHoldings'

type HoldingsListProps = {
  holdings: Holding[]
  ripple?: boolean
  referral?: boolean
  stake?: boolean
  onSelectHolding: (holding: Holding) => void
}

function HoldingsList({
  holdings,
  ripple,
  referral,
  onSelectHolding,
}: HoldingsListProps) {
  return (
    <div className="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 animate-[fade-in_1s_ease-out]">
      {holdings.map((holding) => {
        return (
          <HoldingCard
            ripple={ripple}
            key={holding.name}
            holding={holding}
            onSelectHolding={onSelectHolding}
          />
        )
      })}
    </div>
  )
}

export default memo(HoldingsList)
